import { type CommunityEventFragment } from "@/generated/graphql"
import sdk from "@/api/sdk"
import { useQuery } from "@tanstack/react-query"

const USE_MOCK_DATA = false

const mockEvents: CommunityEventFragment[] = [
  {
    id: "2",
    eventType: "VIRTUAL",
    name: "Mistakes & Lessons: How To Profit in Out-of-State Real Estate Investing",
    startTime: "2025-04-23T18:30:00-04:00",
    address: "",
    venueName: "Zoom Webinar",
    eventUrl: "https://example.com/event2",
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2073&auto=format&fit=crop",
    description:
      "Learn from experienced investors about the common pitfalls and strategies for successful out-of-state real estate investing.",
  },
  {
    id: "3",
    market: {
      city: "Austin",
      state: "TX",
      slug: "austin-tx",
      name: "Austin, TX",
    },
    eventType: "IN_PERSON",
    name: "REI Trivia Night",
    startTime: "2025-04-17T18:30:00-04:00",
    address: "VBGB Beer Hall and Garden/Restaurant",
    venueName: "VBGB Beer Hall and Garden",
    eventUrl: "https://example.com/event3",
    image:
      "https://images.unsplash.com/photo-1511988617509-a57c8a288659?q=80&w=2071&auto=format&fit=crop",
    description:
      "Join us for a fun night of outdoor-themed trivia at REI's community event. Test your knowledge about hiking, camping, and outdoor adventures!",
  },
  {
    id: "4",
    market: {
      city: "Denver",
      state: "CO",
      slug: "denver-co",
      name: "Denver, CO",
    },
    eventType: "IN_PERSON",
    name: "Spring Hiking Series: Beginners Trail Guide",
    startTime: "2025-04-30T09:00:00-04:00",
    address: "Red Rocks Park",
    venueName: "Red Rocks Visitor Center",
    eventUrl: "https://example.com/event4",
    image:
      "https://images.unsplash.com/photo-1551632811-561732d1e306?q=80&w=2070&auto=format&fit=crop",
    description:
      "Learn essential hiking skills for beginners in this guided trail experience through the beautiful Red Rocks Park.",
  },
  {
    id: "5",
    eventType: "VIRTUAL",
    name: "Financial Freedom Through Real Estate",
    startTime: "2025-05-05T18:00:00-04:00",
    address: "",
    venueName: "Online Webinar",
    eventUrl: "https://example.com/event5",
    image:
      "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=2070&auto=format&fit=crop",
    description:
      "Discover proven strategies to achieve financial independence through strategic real estate investments.",
  },
  {
    market: {
      city: "Charlotte",
      state: "NC",
      slug: "charlotte-nc",
      name: "Charlotte, NC",
    },
    eventType: "IN_PERSON",
    id: "1",
    name: "REI Trivia Night",
    startTime: "2025-04-17T18:30:00-04:00",
    address: "VBGB Beer Hall and Garden/Restaurant",
    venueName: "VBGB Beer Hall and Garden",
    eventUrl: "https://example.com/event1",
    image:
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=2069&auto=format&fit=crop",
    description:
      "Join us for a fun night of outdoor-themed trivia at REI's community event. Test your knowledge about hiking, camping, and outdoor adventures!",
  },
]

/**
 * Mock function to simulate getCommunityEvents API call
 * This will be replaced with actual GraphQL query once backend is ready
 */
export const getCommunityEvents = async (): Promise<
  CommunityEventFragment[]
> => {
  if (USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 800))
    return mockEvents
  } else {
    return (await sdk.CommunityEventsQuery())
      .communityEvents as CommunityEventFragment[]
  }
}

/**
 * Hook to fetch and manage community events
 */

export const useCommunityEvents = () => {
  return useQuery({
    queryKey: ["communityEvents"],
    queryFn: async () => {
      return await getCommunityEvents()
    },
  })
}

// When implementing the real API, this will use GraphQL codegen and likely look like:
/*
import { useQuery } from '@tanstack/react-query';
import { graphqlClient } from '../graphql/client';
import {
  GetCommunityEventsDocument,
  GetCommunityEventsQuery
} from '../graphql/generated/graphql';

export const useCommunityEvents = () => {
  return useQuery({
    queryKey: ['communityEvents'],
    queryFn: async () => {
      const { getCommunityEvents } = await graphqlClient.request<GetCommunityEventsQuery>(
        GetCommunityEventsDocument
      );
      return getCommunityEvents;
    }
  });
};
*/
